import { View } from 'react-native';
import { fasPen } from 'shared/@generated/icons/fasPen';
import { Icon } from 'shared/components/icon';
import {
  Caption,
  CroppedPhone,
  IllustrationFrame,
  Photo,
  type IllustrationProps,
  type PhotoTone,
  useIllustrationCopy,
} from './illustration-parts';
import { illustrationPalette as palette } from './illustration-palette';
import type { IllustrationScale } from './illustration-scene';
import type { ExampleBreedKey } from './discovery-parts';

function PetRow({
  s,
  index,
  name,
  breed,
  tone,
}: {
  s: IllustrationScale;
  index: number;
  name: 'pet' | 'second_pet' | 'pet_three';
  breed: ExampleBreedKey;
  tone: PhotoTone;
}) {
  const t = useIllustrationCopy();
  return (
    <View
      testID={'managed-pet-' + index}
      className="relative flex-row items-center"
      style={{ width: s(92), height: s(32), gap: s(6) }}
    >
      <Photo s={s} width={24} height={24} tone={tone} />
      <View className="flex-1" style={{ gap: s(1) }}>
        <View style={{ width: s(44) }}>
          <Caption s={s} size={8.2}>
            {t(name)}
          </Caption>
        </View>
        <Caption s={s} size={6.4} muted>
          {t(breed)}
        </Caption>
      </View>
      <View className="absolute" style={{ right: 0, top: s(3) }}>
        <View
          className="items-center justify-center"
          style={{
            width: s(14),
            height: s(14),
            borderRadius: s(4),
            borderColor: palette.ink + '25',
            borderWidth: s(0.6),
            backgroundColor: palette.paper,
          }}
        >
          <Icon
            icon={fasPen}
            className="text-brand-green-dark"
            style={{ width: s(5), height: s(5) }}
          />
        </View>
      </View>
    </View>
  );
}

export function ManagePets({ transparent = false }: IllustrationProps) {
  const t = useIllustrationCopy();
  return (
    <IllustrationFrame transparent={transparent}>
      {(s) => (
        <CroppedPhone s={s} width={116} y={10}>
          <View style={{ width: s(92), gap: s(5) }}>
            <Caption s={s} size={9.5}>
              {t('animals')}
            </Caption>
            <View style={{ gap: s(4) }}>
              <PetRow s={s} index={0} name="pet" breed="breed" tone="clay" />
              <PetRow s={s} index={1} name="second_pet" breed="breed_ragdoll" tone="olive" />
              <PetRow s={s} index={2} name="pet_three" breed="breed_labrador" tone="forest" />
            </View>
          </View>
        </CroppedPhone>
      )}
    </IllustrationFrame>
  );
}
